var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.702 0H1.298C.581 0 0 .581 0 1.298v15.404C0 17.419.581 18 1.298 18h15.404c.717 0 1.298-.581 1.298-1.298V1.298C18 .581 17.419 0 16.702 0zM6.385 13.605H4.193V7.011h2.192v6.594zM5.289 6.111h-.014c-.736 0-1.212-.507-1.212-1.14 0-.647.49-1.139 1.24-1.139s1.212.492 1.226 1.14c0 .632-.476 1.139-1.24 1.139zm9 7.494h-2.192v-3.527c0-.887-.318-1.492-1.11-1.492-.606 0-.967.408-1.125.802-.058.14-.072.338-.072.535v3.682H7.598s.028-5.975 0-6.594H9.79v.934c.29-.45.812-1.089 1.975-1.089 1.442 0 2.523.943 2.523 2.968v3.781z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b9623998.svg";
export { ForwardRef as ReactComponent };